"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Search } from "lucide-react";
import { useCallback } from "react";
import { PremiumUpgradeDialogHost } from "@/components/layouts/premium-upgrade/premium-upgrade-dialog-host";
import { usePremiumUpgradeRequest } from "@/components/layouts/premium-upgrade/use-premium-upgrade-request";
import { Credenza, CredenzaBody, CredenzaContent, CredenzaDescription, CredenzaHeader, CredenzaTitle } from "@/components/ui/credenza";
import { Input } from "@/components/ui/input";
import { TourCatalogPagination } from "@/features/onboarding-tours/components/tour-catalog-pagination";
import { TourCatalogTourRow } from "@/features/onboarding-tours/components/tour-catalog-tour-row";
import { useOnboardingTours } from "@/features/onboarding-tours/context/use-onboarding-tours";
import type { TourId } from "@/features/onboarding-tours/types/tour-definition";
import { cn } from "@/lib/utils";
export function TourCatalogDialog() {
  const $ = _c(47);
  const {
    catalogOpen,
    setCatalogOpen,
    catalogQuery,
    setCatalogQuery,
    setCatalogPage,
    catalogPageData,
    startTour
  } = useOnboardingTours();
  const premiumUpgrade = usePremiumUpgradeRequest();
  let t0;
  if ($[0] !== setCatalogOpen || $[1] !== startTour) {
    t0 = t1 => {
      const {
        tourId
      } = t1;
      setCatalogOpen(false);
      startTour({
        source: "catalog",
        tourId
      });
    };
    $[0] = setCatalogOpen;
    $[1] = startTour;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleStartTour = t0;
  let t1;
  if ($[3] !== setCatalogPage || $[4] !== setCatalogQuery) {
    t1 = value => {
      setCatalogQuery(value);
      setCatalogPage(0);
    };
    $[3] = setCatalogPage;
    $[4] = setCatalogQuery;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleQueryChange = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("reset-will-change border-0", "motion-reduce:animate-none motion-reduce:duration-0", "flex flex-col max-h-[min(88vh,52rem)] overflow-hidden p-0 gap-0", "w-[min(100vw-1.5rem,72rem)] max-w-[min(100vw-1.5rem,72rem)] sm:max-w-[min(100vw-1.5rem,72rem)]", "[&_button[data-slot=dialog-close-icon]]:bg-muted [&_button[data-slot=dialog-close-icon]]:hover:bg-muted [&_button[data-slot=dialog-close-icon]]:p-1 [&_button[data-slot=dialog-close-icon]]:rounded-md [&_button[data-slot=dialog-close-icon]]:top-3 [&_button[data-slot=dialog-close-icon]]:right-3 [&_button[data-slot=dialog-close-icon]]:flex [&_button[data-slot=dialog-close-icon]]:items-center [&_button[data-slot=dialog-close-icon]]:justify-center [&_button[data-slot=dialog-close-icon]]:size-8");
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-linear-to-br from-primary/8 via-background to-orange/10" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CredenzaHeader className="relative shrink-0 overflow-hidden border-b border-border/50 px-6 py-5">{t3}<div className="relative flex items-start gap-3"><div className="min-w-0 flex-1 pr-8"><CredenzaTitle className="text-xl font-semibold tracking-tight">Product tours</CredenzaTitle><CredenzaDescription className="text-sm text-muted-foreground">Explore guided walkthroughs across Propstrata — from data setup to automations and analytics.</CredenzaDescription></div></div></CredenzaHeader>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Search className="size-4 text-muted-foreground" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleQueryChange) {
    t6 = event => {
      handleQueryChange(event.target.value);
    };
    $[10] = handleQueryChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== catalogQuery || $[13] !== t6) {
    t7 = <div className="shrink-0 border-b border-border/40 bg-muted/20 px-6 py-4"><div className="relative "><Input aria-label="Search tours" beforeIcon={t5} className="h-10 text-sm shadow-none " onChange={t6} placeholder="Search by title, category, or keyword..." value={catalogQuery} wrapperClassName="w-full mx-auto max-w-xl" /></div></div>;
    $[12] = catalogQuery;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("min-h-0 flex-1 overflow-y-auto px-6 py-5", "sm:min-h-[calc(2*10.5rem+0.75rem+2.5rem)]");
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== catalogPageData.rows || $[17] !== handleStartTour || $[18] !== premiumUpgrade.openUpgradeDialog) {
    t9 = <div className={t8}>{catalogPageData.rows.length > 0 ? <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">{catalogPageData.rows.map(row => <TourCatalogTourRow key={row.id} onLockedTourClick={premiumUpgrade.openUpgradeDialog} onStartTour={handleStartTour} row={row} />)}</ul> : <div className="flex min-h-56 flex-col items-center justify-center rounded-xl border border-dashed border-border/70 bg-muted/15 px-6 py-10 text-center"><p className="text-sm font-medium text-foreground">No tours match your search</p><p className="mt-1 max-w-sm text-xs text-muted-foreground">Try a different keyword or clear the search to browse all available tours.</p></div>}</div>;
    $[16] = catalogPageData.rows;
    $[17] = handleStartTour;
    $[18] = premiumUpgrade.openUpgradeDialog;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = catalogPageData.totalCount === 1 ? "" : "s";
  let t11;
  if ($[20] !== catalogPageData.totalCount || $[21] !== t10) {
    t11 = <p className="text-xs text-muted-foreground">{catalogPageData.totalCount} tour{t10} available</p>;
    $[20] = catalogPageData.totalCount;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== catalogPageData.page || $[24] !== catalogPageData.totalPages || $[25] !== setCatalogPage) {
    t12 = <TourCatalogPagination onPageChange={setCatalogPage} page={catalogPageData.page} totalPages={catalogPageData.totalPages} />;
    $[23] = catalogPageData.page;
    $[24] = catalogPageData.totalPages;
    $[25] = setCatalogPage;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div className="shrink-0 border-t border-border/40 bg-muted/10 px-6 py-3"><div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-between">{t11}{t12}</div></div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t7 || $[32] !== t9) {
    t14 = <CredenzaContent className={t2}>{t4}<CredenzaBody className="flex min-h-0 flex-1 flex-col px-0 py-0">{t7}{t9}{t13}</CredenzaBody></CredenzaContent>;
    $[30] = t13;
    $[31] = t7;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== catalogOpen || $[35] !== setCatalogOpen || $[36] !== t14) {
    t15 = <Credenza onOpenChange={setCatalogOpen} open={catalogOpen}>{t14}</Credenza>;
    $[34] = catalogOpen;
    $[35] = setCatalogOpen;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== premiumUpgrade.confirmUpgrade || $[39] !== premiumUpgrade.dialogOpen || $[40] !== premiumUpgrade.dialogPhase || $[41] !== premiumUpgrade.handleDialogOpenChange || $[42] !== premiumUpgrade.isSubmitting) {
    t16 = <PremiumUpgradeDialogHost confirmUpgrade={premiumUpgrade.confirmUpgrade} dialogOpen={premiumUpgrade.dialogOpen} dialogPhase={premiumUpgrade.dialogPhase} handleDialogOpenChange={premiumUpgrade.handleDialogOpenChange} isSubmitting={premiumUpgrade.isSubmitting} />;
    $[38] = premiumUpgrade.confirmUpgrade;
    $[39] = premiumUpgrade.dialogOpen;
    $[40] = premiumUpgrade.dialogPhase;
    $[41] = premiumUpgrade.handleDialogOpenChange;
    $[42] = premiumUpgrade.isSubmitting;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t15 || $[45] !== t16) {
    t17 = <>{t15}{t16}</>;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
}